import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { supabase } from "../lib/supabase";
import { type SongRow, titleOf, isReady } from "../lib/analysis";

type Filter = "all" | "ready" | "easy" | "nocapo";

export function Artist() {
  const { name = "" } = useParams();
  const [songs, setSongs] = useState<SongRow[]>([]);
  const [filter, setFilter] = useState<Filter>("all");

  useEffect(() => {
    supabase.from("songs").select("*")
      .ilike("artist", `%${decodeURIComponent(name)}%`)
      .is("duplicate_of", null)
      .order("plays", { ascending: false })
      .then(({ data }) => setSongs((data ?? []) as SongRow[]));
  }, [name]);

  const shown = songs.filter((song) => {
    if (filter === "ready") return isReady(song);
    if (filter === "nocapo") return !song.capo;
    return true;                       // "easy" needs the chord count, which
  });                                  // lives in the analysis, not the row —
                                       // see the note below.

  return (
    <div className="page">
      <header className="song-head">
        <div>
          <h1 className="serif song-title" style={{ fontSize: 34 }}>
            {decodeURIComponent(name)}
          </h1>
          <p className="muted" style={{ margin: "8px 0 0" }}>
            {songs.length} songs · {songs.filter(isReady).length} analysed
          </p>
        </div>
      </header>

      <div className="controls no-print">
        {([["all", "All"], ["ready", "Ready to play"], ["nocapo", "No capo"]] as const)
          .map(([value, label]) => (
            <button key={value} className="btn" aria-pressed={filter === value}
                    onClick={() => setFilter(value as Filter)}>{label}</button>
          ))}
      </div>

      <ul className="song-list">
        {shown.map((song) => (
          <li key={song.id}>
            <Link to={`/song/${song.slug}`} className="song-row">
              <span className="song-row-main">
                <span className="song-row-title">{titleOf(song)}</span>
                <span className="muted small">
                  {[song.music_key, song.bpm ? `${Math.round(song.bpm)} bpm` : null,
                    song.capo ? `capo ${song.capo}` : null].filter(Boolean).join(" · ")}
                </span>
              </span>
              <span className={isReady(song) ? "tag tag-ready" : "tag tag-working"}>
                {isReady(song) ? "Ready" : "Working"}
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
